// extracted by mini-css-extract-plugin
export default {"container":"zPB9iRqM3Vw5o49bCIb2","titleText":"hteweCxGZMEcju4h3yas"};